"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.Columns = styled_components_1["default"].ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: ", ";\n    grid-column-gap: ", ";\n    grid-row-gap: ", ";\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    @media (max-width: ", ") {\n        justify-items: center;\n        grid-template-columns: repeat(1, 1fr);\n        grid-row-gap: ", ";\n    }\n"], ["\n    display: grid;\n    grid-template-columns: ", ";\n    grid-column-gap: ", ";\n    grid-row-gap: ", ";\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    @media (max-width: ", ") {\n        justify-items: center;\n        grid-template-columns: repeat(1, 1fr);\n        grid-row-gap: ", ";\n    }\n"])), function (_a) {
  var gridTemplateColumns = _a.gridTemplateColumns,
      count = _a.count;
  return gridTemplateColumns || (count ? "repeat(" + count + ", 1fr)" : null);
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing.md;
}, function (_a) {
  var theme = _a.theme,
      breakpoint = _a.breakpoint;
  return breakpoint ? theme.breakpoints[breakpoint] : null;
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing.sm;
});
var templateObject_1;